import React from "react";
import { Message } from "semantic-ui-react";
import { textInputRender } from "../../utils/components";
import { blankHref } from "../../utils/utils";
import FormModal from "../common/FormModal";

type PasswordResetFormModalProps = {
  onSubmit: (values: any) => void;
};

class RecoveryCodesResetFormModal extends React.PureComponent<PasswordResetFormModalProps> {
  render() {
    return (
      <FormModal
        size="mini"
        modalHeader="Disable two-factor authentication device"
        preFormContent={
          <Message info>
            Enter your recovery code in order to disable two-factor authentication device from your
            account.
          </Message>
        }
        fields={[
          {
            name: "recoveryCode",
            render: textInputRender("Recovery code", "Paste in your recovery code", true),
            required: true
          }
        ]}
        onSubmit={this.props.onSubmit}
        modalTrigger={onClick => (
          <div className="field">
            <a href={blankHref} onClick={onClick}>
              Lost access to your two-factor authentication device?
            </a>
          </div>
        )}
      />
    );
  }
}
export default RecoveryCodesResetFormModal;
